import * as requestFromServer from "./UserAssignmentCrud";
import { callTypes, userAssignmentSlice } from "./UserAssignmentSlice";

const {actions} = userAssignmentSlice;

export const getList = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getList()
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getPersonnelUserAndUserGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getPersonnelUserAndUserGroups(queryParams)
    .then(response => {
      dispatch(actions.usersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllPersonnelUserAndUserGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllPersonnelUserAndUserGroups(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getTeacherUserAndUserGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getTeacherUserAndUserGroups(queryParams)
    .then(response => {
      dispatch(actions.usersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllTeacherUserAndUserGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllTeacherUserAndUserGroups(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getStudentUserAndUserGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getStudentUserAndUserGroups(queryParams)
    .then(response => {
      dispatch(actions.usersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllStudentUserAndUserGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllStudentUserAndUserGroups(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getParentUserAndUserGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getParentUserAndUserGroups(queryParams)
    .then(response => {
      dispatch(actions.usersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllParentUserAndUserGroups = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllParentUserAndUserGroups(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getUserGroups = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getUserGroups()
    .then(response => {
      dispatch(actions.userGroupsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getPersonnelUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getPersonnelUsers(queryParams)
    .then(response => {
      dispatch(actions.usersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getTeacherUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getTeacherUsers(queryParams)
    .then(response => {
      dispatch(actions.usersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getStudentUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getStudentUsers(queryParams)
    .then(response => {
      dispatch(actions.usersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getParentUsers = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getParentUsers(queryParams)
    .then(response => {
      dispatch(actions.usersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getPersonnelTypes = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getPersonnelTypes()
    .then(response => {
      dispatch(actions.filtersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getBranches = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getBranches()
    .then(response => {
      dispatch(actions.filtersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getSections = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getSections()
    .then(response => {
      dispatch(actions.filtersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getUserIds = (userGroupId, userType) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getUserIds(userGroupId, userType)
    .then(response => {
      dispatch(actions.userIdsFetched(response.data));
    })
      
    .catch(error => {
      
    });
};

export const saveUsers = (userType, userGroupId, userIds) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveUsers(userType, userGroupId, userIds)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const removeUsers = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .removeUsers(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanList = () => dispatch => {
  return dispatch(actions.listCleaned());
};

export const cleanUserIds = () => dispatch => {
  return dispatch(actions.userIdsCleaned());
};

export const cleanUsers = () => dispatch => {
  return dispatch(actions.usersCleaned());
};